import { Text } from "@chakra-ui/react";
import React from "react";
import Colors from "../../../assets/colors/Colors";

const FormikErrorText = (props) => {
    return (
        <Text
            mt={props.mt ? props.mt : "0.5rem"}
            fontSize="12px"
            lineHeight="15px"
            letterSpacing="-1.5%"
            color={Colors.grubDescriptionColor}
            opacity="0.7"
        >
            {props.error}
        </Text>
    );
};

export default FormikErrorText;
